export const enum RelationCardinalityTypeEnum {
   ONE_TO_ONE = 'ONE_TO_ONE',
   ONE_TO_MANY = 'ONE_TO_MANY',
   MANY_TO_ONE = 'MANY_TO_ONE',
   MANY_TO_MANY = 'MANY_TO_MANY'
}
